module.exports = __webpack_public_path__ + "img/konyu_1.4f2127b1.png";